import _defineProperty from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import { useRouter } from 'next/router';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from '@spotify-internal/encore-web';
import { BannerState } from '../../@mrkt/features/Banner';
import { darkTheme, lightTheme } from '../Theme';
import { Track } from '../Tracking';
import { Layout } from './Layout';
import { LayoutState } from './LayoutState'; // Layout by default renders a dark theme and generic page components like a header and footer.
// In order to sidestep this and render a completely blank layout, add the URL of the page to this array.

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BLANK_LAYOUT_PATHS = ['/m/continue-authentication'];
export var Page = function Page(ctx) {
  var router = useRouter();
  var props = ctx.props,
      Component = ctx.Component;
  var isBlankLayout = BLANK_LAYOUT_PATHS.includes(router.pathname);
  return /*#__PURE__*/_jsx(Track, {
    children: /*#__PURE__*/_jsx(BannerState, {
      children: /*#__PURE__*/_jsx(LayoutState, {
        preview: props === null || props === void 0 ? void 0 : props.preview,
        children: isBlankLayout ? /*#__PURE__*/_jsx(ThemeProvider, {
          theme: lightTheme,
          children: /*#__PURE__*/_jsx(Component, _objectSpread({}, props))
        }) : /*#__PURE__*/_jsx(ThemeProvider, {
          theme: darkTheme,
          children: /*#__PURE__*/_jsxs(Layout, {
            children: [/*#__PURE__*/_jsx(GlobalStyles, {}), /*#__PURE__*/_jsx(Component, _objectSpread({}, props))]
          })
        })
      })
    })
  });
};